import ArabicSection from "@components/ArabicSection";
import ArabicTestimonialSection from "@components/ArabicTestimonialSection";
import ArabicVideoSection from "@components/ArabicVideoSection";
import ClientLogosArabic from "@components/ClientLogosArabic";
import CtaButton from "@components/CtaButton";
import GallaboxBadgesGray from "@components/GallaboxBadgesGray";
import ImageGrid from "@components/ImageGrid";
import Modal from "@components/Modal/Modal";
import NewLayout from "@components/new-ui/Layout";
import PricingTableArabic from "@components/PricingTableArabic";
import YellowCTAhref from "@components/yellowCTAhref";
import cx from "classnames";
import "keen-slider/keen-slider.min.css";
import Head from "next/head";
import Script from "next/script";
import tick from "public/blue-tick.png";
import GreenTickIcon from "public/pricing-page/greentickIcon.png";
import AccountMangerIcon from "public/pricing-page/pricing_account_manager.png";
import BotIcon from "public/pricing-page/pricing_bot.png";
import HighSpeedIcon from "public/pricing-page/pricing_high_speed.png";
import IntegrationIcon from "public/pricing-page/pricing_integration.png";
import LicenseIcon from "public/pricing-page/pricing_license.png";
import tab from "public/tab.png";
import tick2 from "public/white-tick.png";
import React, { FC, ReactElement, useEffect, useMemo } from "react";
import { BsChevronDown } from "react-icons/bs";

const Home: FC = () => {
    const [modalHeader, setModalHeader] = React.useState<string | null>(null);

    const [isMobile, setIsMobile] = React.useState<boolean>(false);
    const [Addclassforvideo, setAddclassforvideo] = React.useState<boolean>(false);
    const [radioValue, setRadioValue] = React.useState<string>("سنوي");
    const [mobile, setMobile] = React.useState<boolean>(false);

    React.useEffect(() => {
        function watchWidth() {
            if (window.innerWidth <= 500) {
                setMobile(true);
            } else {
                setMobile(false);
            }
        }
        watchWidth();
    }, []);

    const pricingTabs = [
        {
            name: "ربع سنوي",
        },
        {
            name: "سنوي",
        },
    ];

    function handleRadioChange(e: { target: { value: any } }) {
        return setRadioValue(e.target.value);
    }

    interface listType {
        content: string;
        tooltip: string;
        isNew?: boolean;
    }
    interface AvatarType {
        name: string;
        image: string;
    }
    interface SubMenu {
        additionalUsers?: JSX.Element;
        icon: string;
        text: ReactElement;
        tooltip?: string;
    }

    interface planDataType {
        id: number;
        name: string;
        price?: string;
        lists?: listType[];
        subText?: any;
        tags?: SubMenu[];
        avatars?: AvatarType[];
        features?: SubMenu[];
        listTitle: string;
        getStarted?: string;
        houseImg: string;
        customFeatures?: SubMenu[];
        additionalUserPrice?: string;
        period?: string;
        cpm?: string;
        idealFor?: string;
    }

    const period = useMemo(() => {
        if (radioValue === "سنوي") {
            return "سنوي";
        } else if (radioValue === "نصف سنوي") {
            return "نصف سنوي";
        } else {
            return "ربع سنوي";
        }
    }, [radioValue]);

    const growthPrice = radioValue === "سنوي" ? "AED550" : "AED179";
    const scalePrice = radioValue === "سنوي" ? "AED991" : "AED1101";
    const proPrice = radioValue === "سنوي" ? "AED1469" : "AED1744";

    const handleClose = () => {
        setModalHeader(null);
    };

    useEffect(() => {
        const width = screen.width;
        if (width < 750) setIsMobile(true);
        setInterval(function () {
            const show = document.querySelector("span[data-show]");
            const next = show?.nextElementSibling || document.querySelector(".first-ch");
            const up = document.querySelector("span[data-up]");

            if (up) {
                up.removeAttribute("data-up");
            }

            show?.removeAttribute("data-show");
            show?.setAttribute("data-up", "");

            next?.setAttribute("data-show", "");
        }, 2000);
    }, []);

    const planData: planDataType[] = [
        {
            id: 1345,
            name: "الشركات",
            idealFor: "منصة أتمتة واتساب مخصصة بالكامل تلبي احتياجات عملك الفريدة",
            getStarted: "كل شيء في الاحترافي، بالإضافة إلى",
            customFeatures: [
                {
                    icon: BotIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white text-right">فوق 25 ترخيص مستخدم</h3>
                        </>
                    ),
                },
                {
                    icon: AccountMangerIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white text-right">محادثة مع الذكاء الاصطناعي</h3>
                        </>
                    ),
                },
                {
                    icon: HighSpeedIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white">استضافة مخصصة</h3>
                        </>
                    ),
                },
                {
                    icon: LicenseIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white">مراسلة عالية السرعة</h3>
                        </>
                    ),
                },
                {
                    icon: IntegrationIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white">الدخول الموحد </h3>
                        </>
                    ),
                },
                {
                    icon: LicenseIcon,
                    text: (
                        <>
                            <h3 className="m-0 p-0 text-base font-normal text-white">التدقيق الأمني</h3>
                        </>
                    ),
                },
            ],
            listTitle: "All in pro ",
            houseImg: "https://assets.gallabox.com/gb-home/pricing-page/house-3.svg",
        },
        {
            id: 1346,
            name: "الاحترافي",
            price: proPrice,
            idealFor: "كل ما تحتاجه لأتمتة أعمالك وتوسيع نطاقها على واتساب",

            getStarted: "كل شيء في الاحترافي، بالإضافة إلى",

            tags: [
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0">حتى 6 مستخدمين</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal inline  m-0 p-0">أدوات المحادثة المتقدمة*</h3>
                        </>
                    ),
                    tooltip: "Open AI/Chat GPT powered WhatsApp bot",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base  font-normal inline  m-0 p-0">تقسيم احترافي/حملات</h3>
                        </>
                    ),
                    tooltip: "Broadcast through API",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base  font-normal inline  m-0 p-0">المساعدة في الإعداد وإعداد الحساب</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0">عملية تكامل متقدمة لتطبيقات الأعمال + أداة المحادثة + عمليات تكامل مخصصة</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0">تكاملات واجهة برمجة التطبيقات المخصصة</h3>
                        </>
                    ),
                },
            ],
            avatars: [
                {
                    name: "robot-1",
                    image: "https://assets.gallabox.com/gb-home/pricing-page/robo-1.svg",
                },
                {
                    name: "robot-2",
                    image: "https://assets.gallabox.com/gb-home/pricing-page/robo-3.svg",
                },
            ],
            listTitle: "All in Growth +",
            houseImg: "https://assets.gallabox.com/gb-home/pricing-page/house-2.svg",
            period: period,
            cpm: "4,500",
        },
        {
            id: 1347,
            name: "الحجم",
            price: scalePrice,
            idealFor: "فرق نمو سريعة تحتاج إلى أتمتة التسويق عبر واتساب",
            getStarted: "كل شيء في النمو، بالإضافة إلى",

            tags: [
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className=" text-base font-normal  m-0 p-0" style={{ color: "#3182CE" }}>
                                حتى 6 مستخدمين
                            </h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className=" text-base font-normal inline  m-0 p-0" style={{ color: "#3182CE" }}>
                                أدوات المحادثة الحرجة
                            </h3>
                        </>
                    ),
                    tooltip: "Multiple WA Channels, Limited AI Rewrite, Custom Fields",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className=" text-base font-normal inline  m-0 p-0" style={{ color: "#3182CE" }}>
                                تقسيم/حملات متقدمة
                            </h3>
                        </>
                    ),
                    tooltip: "Instant broadcast through excel",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-base font-normal inline  m-0 p-0" style={{ color: "#3182CE" }}>
                                منشئ الروبوت مع الموصلات المتقدمة
                            </h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className=" text-base font-normal inline  m-0 p-0" style={{ color: "#3182CE" }}>
                                15 عملية تكامل هامة لتطبيقات الأعمال
                            </h3>
                        </>
                    ),
                    tooltip: "Bot utilities, actions and connectors",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className=" text-base font-normal  m-0 p-0" style={{ color: "#3182CE" }}>
                                المراسلة/البث/القوالب وواجهات برمجة التطبيقات وخطافات الويب
                            </h3>
                        </>
                    ),
                },
            ],
            avatars: [
                {
                    name: "robot-1",
                    image: "https://assets.gallabox.com/gb-home/pricing-page/robo-1.svg",
                },
                {
                    name: "robot-2",
                    image: "https://assets.gallabox.com/gb-home/pricing-page/robo-3.svg",
                },
            ],
            listTitle: "All in Growth +",
            houseImg: "https://assets.gallabox.com/gb-home/pricing-page/house-2.svg",
            period: period,
            cpm: "4,500",
        },
        {
            id: 1348,
            name: "النمو",
            price: growthPrice,
            idealFor: "للأشخاص الذين يتطلعون إلى تبسيط التواصل مع العملاء على واتساب",
            getStarted: "ابدأ مجانًا",

            tags: [
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0">حتى 6 مستخدمين</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base inline font-normal  m-0 p-0">أدوات المحادثة الأساسية </h3>
                        </>
                    ),
                    tooltip: "Single WA Channel, Opt-In Management, Follow Up",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal inline  m-0 p-0">تقسيم/حملات بسيطة</h3>
                        </>
                    ),
                    tooltip: "Contact filter segments",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0">الإعداد الذاتي</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base inline font-normal  m-0 p-0">منشئ الروبوت الأساسي </h3>
                        </>
                    ),
                    tooltip: "No-Code tools to build your bot",
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base font-normal  m-0 p-0"> 10عمليات تكامل أساسية لتطبيقات الأعمال</h3>
                        </>
                    ),
                },
                {
                    icon: GreenTickIcon,
                    text: (
                        <>
                            <h3 className="text-gray-500 text-base inline font-normal  m-0 p-0">واجهة برمجة تطبيقات المراسلة الأساسية</h3>
                        </>
                    ),
                    tooltip: "Message & Contact API",
                },
            ],
            avatars: [
                {
                    name: "single-robot",
                    image: "https://assets.gallabox.com/gb-home/pricing-page/robo-3.svg",
                },
            ],
            listTitle: "Growth plan includes",
            houseImg: "https://assets.gallabox.com/gb-home/pricing-page/house-1.svg",
            period: period,
            cpm: "1,000",
        },
    ];

    return (
        <NewLayout
            keywords="برمجيات دعم العملاء متعددة القنوات، واجهة برمجة واتساب للأعمال، روبوت محادثة واتساب، صندوق وارد مشترك في واتساب، إدارة نجاح العملاء، إدارة العملاء المحتملين."
            title="جالابوكس | التَّلقائية لواتساب للأعمال والروبوتات في المحادثات عبر واتساب"
            description="جالابوكس هو مساحة عمل بدون كود يُمكن من استخدام قوة واتساب لتوسيع نطاق عملك من خلال صندوق وارد مشترك، روبوت محادثات واتساب بدون كود، بث رسائل واتساب والمزيد."
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ar/Home-og.png" }}
            withLiveChat
            canonical="https://gallabox.com/ar"
            isFreezone
            isArabic
        >
            <Script src="https://fast.wistia.com/embed/medias/730lmkyzty.jsonp" async />
            <Script src="https://fast.wistia.com/assets/external/E-v1.js" async />
            <Head>
                <link rel="alternate" hrefLang="en" href="https://gallabox.com/" />
                <link rel="alternate" hrefLang="en-us" href="https://gallabox.com/us" />
                <link rel="alternate" hrefLang="ar" href="https://gallabox.com/ar" />
                <link rel="alternate" hrefLang="x-default" href="https://gallabox.com/" />
            </Head>

            <section className="relative app-home pt-[68px] bg-white" style={{ zIndex: 0 }}>
                <header className="relative mx-auto md:mt-16 " style={{ width: "100%", maxWidth: "1600px" }}>
                    <div className="absolute home-brown"></div>
                    <div className="absolute home-white"></div>
                    <div className="absolute home-blue"></div>
                    <div style={{ paddingTop: 50 }}>
                        <div className="flex lg:flex-row flex-col lg:max-w-2xl  max-w-6xl  mx-auto">
                            <div
                                className="text-green-700 bg-green-200 wati-top-green font-bold flex flex-nowrap lg:mx-0 mx-auto relative"
                                style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid #AAF0C4" }}
                            >
                                <p className=" pr-2" style={{ color: "#087443" }}>
                                    مدعوم من واجهة برمجة تطبيقات واتساب للأعمال الرسمية
                                </p>
                                <span className="wa-control-img">
                                    <img
                                        height={"24px"}
                                        width={"24px"}
                                        src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                        className="ml-2"
                                        style={{ margin: 0 }}
                                        alt="white-border-whatsapp-icon"
                                    />
                                </span>
                            </div>
                            <img className="z-1 lg:mx-0 mx-auto" src="/nav-icons/meta-head.svg" style={{ height: "30px" }} alt="" />
                        </div>

                        <h3 className="head-title mx-auto text-center md:w-4/5 mt-5 md:mt-0 relative " style={{ marginBottom: "13px" }}>
                            <span>
                                حوّل محادثات عملائك إلى
                                <span>
                                    <span className="hidden md:inline">
                                        <div className="inline-block sm-white-blk"></div>
                                        <img className="header-leaf" src="https://assets.gallabox.com/gb-home/home/yellow-drops.svg" alt="" />
                                    </span>
                                </span>
                            </span>
                            <span className="block">
                                <span className=" text-blue-500">عملاء محتملين</span>
                            </span>
                        </h3>
                        <p className="z-2 relative sub-head text-center md:w-5/12 mx-auto">
                            أطلق العنان لقوة الروبوتات من خلال سهولة إرسال الرسائل <br /> لزيادة المبيعات وإسعاد العملاء.
                        </p>
                    </div>
                    <div className="relative  home-hero-image-container pt-24 lg:pb-8">
                        <div className="absolute mx-auto md:inset-x-1/4 top-0 md:-top-8 home-button">
                            <div className="w-fit mx-auto py-4">
                                <CtaButton type="large" text={" سجل مجانًا"} />
                            </div>
                            <div className="flex mt-2 items-center gap-4 mx-auto w-fit">
                                {["لا توجد رسوم الإعداد.", "سهل الاستخدام."].map((each) => {
                                    return (
                                        <div className="flex items-center gap-1 md:gap-2" key={each}>
                                            <p className="head-points text-gray-700">{each}</p>
                                            <img src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg" alt="Green Checkmark" className="" />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="relative">
                            {isMobile ? (
                                <img src="https://assets.gallabox.com/gb-home/home/home-page-phone.png" alt="" className="phone-pic relative top-26" />
                            ) : (
                                <img src="https://assets.gallabox.com/gb-home/home-header-new.png" alt="" className="mx-auto relative top-20" />
                            )}
                        </div>
                    </div>
                    <img src="https://assets.gallabox.com/gb-home/gif/Conversation.gif" alt="conversation gif" className="absolute msg-gif  top-72 left-64  hidden md:inline" />
                    <img
                        style={{ top: "415px", right: "65px" }}
                        src="https://assets.gallabox.com/gb-home/gif/text-msg.gif"
                        alt="msg gif"
                        className="absolute msg-gif invisible  md:visible"
                    />
                </header>

                <section className="client-logos pt-2 md:pt-0 lg:px-44">
                    <ClientLogosArabic />
                </section>
                <ArabicVideoSection botIconSrc="https://assets.gallabox.com/gb-home/ai/herosection-mp4.mp4" />
                <ArabicSection
                    heading="روبوتات بدون تعليمات برمجية لأتمتة محادثات عملائك على الواتساب"
                    point1="النشر على الفور من مكتبة قوالب الروبوت المعدة مسبقًا عبر حالات الاستخدام المتعددة"
                    point2="تخصيص تدفق روبوت الدردشة عندما تريد دون أي مساعدة فنيةتخصيص تدفق روبوت الدردشة عندما تريد دون أي مساعدة فنية"
                    point3="التكامل بسلاسة مع نظام إدارة علاقات العملاء الخاص بك وتطبيقات الأعمال الهامة الأخرى"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section1.png"
                />
                <ArabicSection
                    isImageRightSide
                    heading="البريد الوارد للفريق المشترك يجعل التعاون بين الفريق أمرًا سهلاً للغاية"
                    point1="احصل على سياق في الوقت الفعلي وعرض 360 درجة لجميع محادثات العملاء"
                    point2="السماح للوكلاء بمشاركة التحديثات المباشرة والتعاون بشكل أفضل من خلال الإشارات والملاحظات"
                    point3="قل وداعًا لمنحنيات التعلم الطويلة من خلال واجهة بديهية تشبه واجهة واتساب"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section2.png"
                />
                <ArabicSection
                    heading="حملات بث مخصصة لخط أنابيب مبيعات قوي"
                    point1="إنشاء شرائح العملاء على أساس السمات والسلوك الماضي"
                    point2="أضف عناصر تفاعلية ووسائط غنية لإنشاء رسائل جذابة"
                    point3="احصل على تحليلات قابلة للتنفيذ للحملة مثل المقاييس المرسلة والمسلمة والقراءة والرد"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section3.png"
                />
                <ArabicSection
                    isImageRightSide
                    heading="قم بدمج كتالوج المنتجات الخاصة بك وبيعها من خلال واتساب"
                    point1="اعرض كتالوج المنتجات الخاصة بك وشاركه مع العملاء على واتساب"
                    point2="إرسال تأكيد الطلب وتحديثات الفواتير من خلال رسائل الواتساب"
                    point3="تحويل واتساب الأعمال إلى قناة المبيعات الأكثر فعالية لديك"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section4.png"
                />
                <ArabicSection
                    heading="إنشاء وإرسال تسلسل تلقائي لرسائل واتساب"
                    point1="إرسال سلسلة من الرسائل إلى جهات الاتصال الخاصة بك على مدى فترة بترتيب محدد سلفًا"
                    point2="قم بزيادة مشاركة عملائك دون عناء باستخدام حملات واتساب بالتقطير"
                    point3="إلحاق العملاء، وإرسال رسائل تذكير بالدفع، ومشاركة تحديثات إطلاق المنتج، والمزيد"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section5.png"
                />

                <YellowCTAhref
                    text2="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    buttonText=" لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    customText=" أطلق العنان للإمكانات الكاملة لأداة واتساب الخاصة بنا من خلال خيارات التسعير المرنة لدينا"
                />

                <div className="bg-white  p-10">
                    <img src={tab} className=" w-44 h-16 mx-auto" alt="" />
                    <div className="pricing-tabs  mx-auto  flex items-center justify-evenly gap-4">
                        {pricingTabs.map((each) => {
                            return (
                                <div key={each.name} style={{ fontWeight: radioValue === each.name ? 700 : 400 }}>
                                    <label htmlFor={each.name} className="container cursor-pointer">
                                        <input
                                            type="radio"
                                            value={each.name}
                                            id={each.name}
                                            onChange={handleRadioChange}
                                            checked={radioValue === each.name}
                                            className="cursor-pointer"
                                        />
                                        {each.name}
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className=" pricing " id="plan">
                    <section
                        className={cx("flex mt-0 pt-0 pb-10 md:py-10 gap-4 justify-between mx-auto bg-white ", { "flex-col w-full items-center gap-6": mobile })}
                        style={{ maxWidth: "1166px" }}
                    >
                        {planData.map((eachCard) => {
                            return (
                                <Plan
                                    key={eachCard.id}
                                    price={eachCard.price as string}
                                    title={eachCard.name}
                                    list={eachCard.lists}
                                    tags={eachCard.tags}
                                    customFeatures={eachCard.customFeatures}
                                    avatar={eachCard.avatars}
                                    listTitle={eachCard.listTitle}
                                    houseImg={eachCard.houseImg}
                                    additionalUserPrice={eachCard.additionalUserPrice}
                                    getStarted={eachCard.getStarted}
                                    period={eachCard.period}
                                    cpm={eachCard.cpm}
                                    subText={eachCard.subText as undefined}
                                    idealFor={eachCard.idealFor}
                                    features={eachCard.features}
                                />
                            );
                        })}
                    </section>

                    <section className=" lg:block hidden pricing-more-info bg-white  mb-10" style={{ marginTop: "-1px" }}>
                        <input className="absolute hidden" id="more-info" type="checkbox" />
                        <label htmlFor="more-info" className=" pb-10 flex flex-row justify-center w-full leading-normal cursor-pointer items-center">
                            <p className=" m-0 text-blue-500 tracking-wider text-sm text-center">المقارنة الكاملة بين الخطط</p>
                            <span className="expand-toggle-icon flex justify-center items-center rounded-full h-8 ml-2">
                                <BsChevronDown />
                            </span>
                        </label>
                        <PricingTableArabic growthPrice={growthPrice} scalePrice={scalePrice} proPrice={proPrice} />
                    </section>
                </div>
                <section className="pt-10">
                    <GallaboxBadgesGray ArabicText="المستهلكون يحبونا" />
                </section>
                <div className="mx-auto " style={{ maxWidth: "1440px" }}>
                    <ArabicTestimonialSection />
                </div>
                <ImageGrid
                    buttonTxt="البدء"
                    href="https://app.gallabox.com/signup"
                    title="التكامل"
                    description="توصيل الكومبيوتر مع جالابوكس بسهولة"
                    content="هل لديك مجموعة برامج متنوعة؟ لا مشكلة! ستتماشى جالابوكس بشكل مثالي من خلال التكامل السلس مع البرمجيات الحالية لديك، سواء كانت نظم إدارة العلاقات مع العملاء أو معالجي الدفع."
                />

                <section className="relative" style={{ background: "#002055" }}>
                    <div className="max-w-6xl mx-auto py-20 px-4 flex flex-col items-center">
                        <h4 className="p-0 m-0 tracking-wider text-base uppercase font-bold text-center text-caribbean-green">شاهد الفيديو</h4>
                        <h3 className="p-0 m-0 text-2xl lg:text-3xl font-medium text-center max-w-screen-md leading-snug tracking-wide text-white mt-2">
                            Gallabox تعرف على المزيد عن
                        </h3>
                        <div className="track_videoplay wistia_responsive_padding rounded-xl z-1 mt-10 w-full max-w-screen-md relative" style={{ padding: "46.25% 0 0 0" }}>
                            <div className="wistia_responsive_wrapper h-full w-full absolute top-0 left-0">
                                <div className="wistia_embed wistia_async_730lmkyzty videoFoam=true" style={{ height: "100%", position: "relative", width: "100%" }}>
                                    <div
                                        className={`${Addclassforvideo && "videoopacity"} wistia_swatch`}
                                        style={{
                                            height: "100%",
                                            left: "0",
                                            opacity: "0",
                                            overflow: "hidden",
                                            position: "absolute",
                                            top: "0",
                                            transition: "opacity 200ms",
                                            width: "100%",
                                        }}
                                    >
                                        <img
                                            src="https://fast.wistia.com/embed/medias/730lmkyzty/swatch"
                                            style={{ filter: "blur(5px)", height: "100%", objectFit: "contain", width: "100%" }}
                                            alt=""
                                            aria-hidden="true"
                                            onLoad={() => setAddclassforvideo(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img alt="" className="absolute top-0 left-0 right-0 bottom-0 w-full" src="https://assets.gallabox.com/gb-home/home/wave-bg.webp" />
                </section>
                <YellowCTAhref
                    text2="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    buttonText="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    customText=" أطلق العنان للإمكانات الكاملة لأداة واتساب الخاصة بنا من خلال خيارات التسعير المرنة لدينا"
                />
            </section>
            {modalHeader && <Modal onClose={handleClose} modalHeader={modalHeader} ctaLabel={modalHeader} subjectSuffix={` [${modalHeader}]`} />}
        </NewLayout>
    );
};

interface listType {
    content: string;
    isNew?: boolean;
    tooltip?: any;
}
interface AvatarType {
    name: string;
    image: string;
}

interface ToolTipdata {
    text: string;
    tooltip?: string;
}

interface SubMenu {
    additionalUsers?: JSX.Element;
    icon: string;
    text: ReactElement;
    tooltip?: string;
}
interface PlanProps {
    price: string;
    title: string;
    list?: listType[];
    subText?: ToolTipdata;
    features?: SubMenu[];
    tags?: SubMenu[];
    avatar?: AvatarType[];
    listTitle?: string;
    houseImg: string;
    additionalUserPrice?: string;
    period?: string;
    getStarted?: string;
    cpm?: string;
    customFeatures?: SubMenu[];
    isMobile?: boolean;
    idealFor?: string;
    additionalUsers?: string;
}

const Plan: FC<PlanProps> = (props) => {
    const inrLink = "https://docs.gallabox.com/pricing-and-billing-modules/conversation-pricing#whatsapp-conversation-pricing-in-inr";

    const chosenLink = inrLink;

    const { price, title, getStarted, tags, idealFor, additionalUserPrice, period, features, subText, customFeatures } = props;
    const containerStyle = {
        backgroundColor: title === "الشركات" ? "#3182CE" : title === "الحجم" ? "#EBF8FF" : "initial",
        color: title === "الشركات" ? "white" : "initial",
    };
    const isCustom = Boolean(title === "الشركات");
    const isScale = Boolean(title === "الحجم");
    return (
        <div className="pricing-card-wrap mb-10">
            {!isScale ? (
                <article className="pricing-card-ar relative text-right " style={containerStyle}>
                    <p className="p-0 m-0 tracking-wider text-2xl  font-medium text-right ">{title}</p>
                    {idealFor && (
                        <div className={`flex gap-1 justify-center py-5 ${isCustom ? "text-white" : ""}`}>
                            <p className="" style={{ fontSize: "16px", color: isCustom ? "white" : "#4a5568" }}>
                                {idealFor}
                            </p>
                        </div>
                    )}
                    <div className=" text-right">
                        <h3 className="price p-0 m-0 font-normal text-base">{price}</h3>
                        <p className="price-description ">{title === "الشركات" ? "" : `شهريا الفاتورة ${period}`}</p>

                        {title === "الشركات" ? (
                            <div className=" pt-16 mt-2">
                                <a href="https://tally.so/r/nP1Wq5" target="_blank" rel="noreferrer" className="hover:no-underline  ">
                                    <button className="try-btn-custom bg-white text-blue-500 w-11/12 border-blue-500 mx-auto block mt-4">تحدث معنا</button>
                                </a>
                            </div>
                        ) : (
                            <a href="https://app.gallabox.com/signup" target="_blank" rel="noreferrer" className="hover:no-underline ">
                                <button className="try-btn-new bg-blue-500  w-11/12 mx-auto block mt-4">بدأ النسخة التجريبية المجانية</button>
                            </a>
                        )}
                    </div>
                    {subText && (
                        <div className=" py-4">
                            <h3 className="bg-green-50 font-light text-sm text-green-500 p-0 m-0 text-center">
                                <div className="flex flex-row">
                                    <p className="flex items-center">
                                        {subText.text}
                                        {/* {subText.tooltip && (
                                            <span className="relative ml-1 lg:mb-5 mb-0">
                                                <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                <div className={"pricing-tooltip-content"}>{subText.tooltip}</div>
                                            </span>
                                        )} */}
                                    </p>
                                </div>
                            </h3>
                            <div className="text-blue-500 text-sm pt-2 text-center font-bold ">
                                <a className="" target="_blank" rel="noreferrer" href={chosenLink}>
                                    WhatsApp Conversation Charges
                                </a>
                            </div>
                        </div>
                    )}
                    <div className={`p-2 mt-4 ${title === "الشركات" ? "" : ""}`} style={{ borderTop: "1px solid #CBD5E0" }} />
                    {isCustom ? (
                        <div className="feature-list flex flex-col gap-8">
                            <p className="font-medium text-xs text-white text-right ">{getStarted}</p>
                            {customFeatures?.map((v, idx) => {
                                return (
                                    <div key={idx} className="w-full">
                                        <div className="each-row text-right">
                                            <div className="flex flex-row gap-3 m-0 w-full text-right">
                                                <div className="text-right w-48">{v.text}</div>
                                                <img src={title === "الشركات" ? tick2 : tick} className="w-5 h-5" alt="Tick Mark" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : null}
                    {additionalUserPrice && (
                        <div className="mb-5 py-4" style={{ borderTop: "1px dashed #CBD5E0", borderBottom: "1px dashed #CBD5E0" }}>
                            <img src="" alt="" />
                            <p className="tracking-wide font-normal text-sm" style={{ color: "#1A202C" }}>
                                Additional User <span className="font-bold text-black text-lg">{additionalUserPrice}</span> per month
                            </p>
                        </div>
                    )}
                    {(tags?.length ?? 0) > 0 && (
                        <div>
                            <div className="">
                                <p className="font-medium text-xs text-gray-400 text-right">{getStarted}</p>
                            </div>
                            <div className="flex flex-wrap  gap-2 py-4 text-right" style={{ height: "360px" }}>
                                {tags?.map((v, idx) => {
                                    return (
                                        <div key={idx} className="flex flex-row gap-3 text-right">
                                            <div className="m-0">
                                                {/* {v.tooltip && (
                                                        <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                            <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                            <div className={"pricing-tooltip-content"}>{v.tooltip}</div>
                                                        </span>
                                                    )} */}
                                                <div className="w-48">{v.text}</div>
                                            </div>
                                            <img src={tick} alt="Blue Tick" className="w-5 h-5" />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    <div className="flex flex-wrap gap-2 py-4">
                        {features?.map((v, idx) => {
                            return (
                                <div key={idx} className="flex flex-row gap-3 text-right">
                                    <div className="m-0">
                                        {/* {v.tooltip && (
                                                <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                    <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                    <div className={"pricing-tooltip-content"}>{v.tooltip}</div>
                                                </span>
                                            )} */}
                                        <div className="w-48">{v.text}</div>
                                        <img src={tick} alt="Blue Tick" className="w-5 h-5" />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </article>
            ) : (
                <div className="scale-wrap">
                    <div className="most-popular py-2" style={{ backgroundColor: "#3182CE" }}>
                        MOST POPULAR
                    </div>
                    <article className="pricing-card-ar relative text-right" style={{ ...containerStyle, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                        <p className="p-0 m-0 tracking-wider text-2xl  font-medium text-right ">{title}</p>
                        {idealFor && (
                            <div className="flex gap-1 justify-center py-5">
                                <p className=" text-base">{idealFor}</p>
                            </div>
                        )}
                        <div>
                            <h3 className="price p-0 m-0 font-normal text-base">{price}</h3>
                            <p className="price-description ">{`شهريا الفاتورة ${period}`}</p>

                            <a href="https://app.gallabox.com/signup" target="_blank" rel="noreferrer" className="hover:no-underline ">
                                <button className="try-btn-new bg-blue-500  w-11/12 mx-auto block mt-4">بدأ النسخة التجريبية المجانية</button>
                            </a>
                        </div>

                        {subText && (
                            <div className=" py-4">
                                <h3 className="bg-green-50 font-light text-sm text-green-500 p-0 m-0 text-center">
                                    <p className="flex items-center">
                                        {subText.text}
                                        {/* {subText.tooltip && (
                                            <span className="relative ml-1 lg:mb-5 mb-0">
                                                <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                <div className={"pricing-tooltip-content"}>{subText.tooltip}</div>
                                            </span>
                                        )} */}
                                    </p>
                                </h3>
                                <div className="text-blue-500 text-sm pt-2 text-center font-bold ">
                                    <a className="" target="_blank" rel="noreferrer" href={chosenLink}>
                                        WhatsApp Conversation Charges
                                    </a>
                                </div>
                            </div>
                        )}

                        <div className="p-2 mt-4" style={{ borderTop: "1px solid #CBD5E0" }} />

                        {additionalUserPrice && (
                            <div className="mb-5 py-4" style={{ borderTop: "1px dashed #CBD5E0", borderBottom: "1px dashed #CBD5E0" }}>
                                <img src="" alt="" />
                                <p className="tracking-wide font-normal text-sm" style={{ color: "#1A202C" }}>
                                    Additional User <span className="font-bold text-black text-lg">{additionalUserPrice}</span> per month
                                </p>
                            </div>
                        )}
                        {(tags?.length ?? 0) > 0 && (
                            <div>
                                <div className="">
                                    <p className="font-medium text-x text-right" style={{ color: "#3182CE" }}>
                                        {getStarted}
                                    </p>
                                </div>

                                <div className="flex flex-wrap  gap-2 py-4 text-right " style={{ height: "360px" }}>
                                    {tags?.map((v, idx) => {
                                        return (
                                            <div key={idx} className="flex flex-row gap-3 text-right">
                                                <div className="m-0">
                                                    {/* {v.tooltip && (
                                                            <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                                <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                                <div className={"pricing-tooltip-content"}>{v.tooltip}</div>
                                                            </span>
                                                        )} */}
                                                    <div className="w-48">{v.text}</div>
                                                </div>
                                                <img src={tick} alt="Blue Tick" className="w-5 h-5" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        <div className="flex flex-wrap  gap-2 py-4 text-right">
                            {features?.map((v, idx) => {
                                return (
                                    <div key={idx} className="flex flex-row gap-3 text-right">
                                        <div className="m-0">
                                            {/* {v.tooltip && (
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="i" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{v.tooltip}</div>
                                                    </span>
                                                )} */}
                                            <div className="w-48">{v.text}</div>
                                        </div>
                                        <img src={tick} alt="Blue Tick" className="w-5 h-5" />
                                    </div>
                                );
                            })}
                        </div>
                    </article>
                </div>
            )}
        </div>
    );
};
export const MobilePlan: FC<PlanProps> = (props) => {
    const { price, title, period } = props;

    return (
        <div className="mobile-plan-pricing relative">
            <p className="p-0 m-0 tracking-wider text-xl uppercase font-bold text-center" style={{ color: "#00D4AB" }}>
                {title}
            </p>
            <div>
                <h3 className="price p-0 m-0 pt-2 text-center font-bold" style={{ fontSize: "38px" }}>
                    {price}
                </h3>
                <p className="price-description">per month for billed {period}</p>
                {title === "الشركات" ? (
                    <a
                        href="https://crm.zoho.in/bookings/DemoandOnboardingSupport?rid=8bae18f94f1a06ffe8366dbcc2cb4025428d1f6813449a6131d0c3dabb9dce58gid07ce26a4507f35aca99f7bf0b9a64938258485602df6dd64bf00dfe6109fd15d"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:no-underline "
                    >
                        <button className=" bg-blue-500 w-full mx-auto block my-4">Talk to us</button>
                    </a>
                ) : (
                    <a href="https://app.gallabox.com/signup" target="_blank" rel="noreferrer" className="hover:no-underline ">
                        <button className=" bg-blue-500 to-blue-500 w-full mx-auto block my-4">بدأ النسخة التجريبية المجانية</button>
                    </a>
                )}
            </div>
        </div>
    );
};

export default Home;
